import Vue from 'vue'

export default {
  text : {
    "main_title": 'Košík',
    "billing-address" : "Fakturační adresa",
    "orders-customer": "Objednávky",

    "option-yes": "Ano",
    "option-no": "Ne",

    "dayNames" : ["Neděle", "Pondělí", "Úterý", "Středa", "Čtvrtek", "Pátek", "Sobota"],
    "dayNamesShort" : ["Ne", "Po", "Út", "St", "Čt", "Pá", "So"],

    "cart-is-empty": "Zatím tu nic není 😔. Naplníme? 🙃",
    "product-question-delete": "Opravdu chcete odebrat tentoprodukt z košíku?",

    "button-login-continue": "Pokračovat",
    "login-info-line-1": "Na e-mail <b>%0</b><br>letí přihlašovací kód.",
    "login-info-line-2": "Otevřít ho můžete i na jiném zařízení a pokračovat tady!",
    "button-login-send-again": "Poslat nový kód",
    "button-login-reset": "Špatný e-mail?",
    "login-welcome": "Vítejte zpátky, %0!",
    "login-rules": 'Přihlášením souhlasím s&nbsp;<a target="_blank" href="%0">obchodními&nbsp;podmínkami</a>',
    // "login-newsletter": 'Občas chci dostat <a target="_blank" href="%0">newsletter</a>',
    "login-newsletter": 'Občas chci dostat newsletter',
    "login-code-error": "Zadaný kód je chybný.",
    "": "",
    "": "",
    "": "",
    "": "",
    "": "",
    "": "",
    "": "",

    "delivery-slots-info": "Na tento den lze objednat už jen %0 minut.",
    "delivery-slot-no-longer-available": "Vybraný čas doručení již není k dispozici, vyberte si jiný.",
    "": "",

    "invoice-note": "Poznámka na fakturu",
    "": "",
    "": "",
    "": "",

    "NO_CART_ID": "Není definován košík.",
    "NO_PROD_LEFT": "Není možné objednat tolik produktů.",
  }
}
